// extracted by css-extract-rspack-plugin
export default {"cls1":"JJHomePageSearch-cls1_jUg","cls2":"JJHomePageSearch-cls2_aDZ JJHomePageSearch-cls1_jUg","collapsed":"JJHomePageSearch-collapsed_AXi"};